export default "__VITE_PUBLIC_ASSET__446ba828__"